var _circle, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorfinder = function SvgColorfinder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.857,
    cy: 10.857,
    r: 5.965,
    stroke: "#fff",
    transform: "rotate(-45 10.857 10.857)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#colorfinder_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "colorfinder_svg__b",
    width: 10,
    height: 10,
    x: 6,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.858,
    cy: 10.857,
    r: 4.242,
    fill: "#D9D9D9",
    transform: "rotate(-45 10.858 10.857)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#colorfinder_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#colorfinder_svg__c)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2412.53,
    height: 2412.53,
    x: -1206.27,
    y: -1206.27,
    transform: "rotate(44.971 -7.686 18.526)scale(.00424)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,#eb5143 0deg,#f0f43c 121.815deg,#4c89e8 252.602deg,#eb5143 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.859 10.857 6-6 5.998 6-5.999 5.999z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.94354903697967529,\"g\":0.95750916004180908,\"b\":0.23624084889888763,\"a\":1.0},\"position\":0.33837437629699707},{\"color\":{\"r\":0.29841524362564087,\"g\":0.53851240873336792,\"b\":0.91340112686157227,\"a\":1.0},\"position\":0.70167320966720581},{\"color\":{\"r\":0.92161113023757935,\"g\":0.32063350081443787,\"b\":0.26318705081939697,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.94354903697967529,\"g\":0.95750916004180908,\"b\":0.23624084889888763,\"a\":1.0},\"position\":0.33837437629699707},{\"color\":{\"r\":0.29841524362564087,\"g\":0.53851240873336792,\"b\":0.91340112686157227,\"a\":1.0},\"position\":0.70167320966720581},{\"color\":{\"r\":0.92161113023757935,\"g\":0.32063350081443787,\"b\":0.26318705081939697,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":5.9992523193359375,\"m01\":-5.9992523193359375,\"m02\":10.858108520507812,\"m10\":5.9992523193359375,\"m11\":5.9992523193359375,\"m12\":4.8576817512512207},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.905 15.665.762-.762 4.23 4.23-.762.762z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "colorfinder_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.859 10.857 6-6 5.998 6-5.999 5.999z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorfinder_svg__a",
    width: 10.484,
    height: 10.484,
    x: 5.616,
    y: 5.615,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_844_6223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_844_6223",
    result: "shape"
  })))));
};
export default SvgColorfinder;